import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

type CampaignPublishToggleProps = {
  event: { id: string; status: 'draft' | 'published' }
}

export default function CampaignPublishToggle({ event }: CampaignPublishToggleProps) {
  const [busy, setBusy] = useState(false)
  const published = event.status === 'published'

  function toggle(next: boolean) {
    router.patch(
      `/dashboard/events/${event.id}/${next ? 'publish' : 'unpublish'}`,
      {},
      {
        preserveScroll: true,
        onStart: () => setBusy(true),
        onFinish: () => setBusy(false),
      },
    )
  }

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="campaign-publish"
        checked={published}
        disabled={busy}
        onCheckedChange={toggle}
      />
      <Label htmlFor="campaign-publish" className="cursor-pointer">
        {published ? 'Published' : 'Draft'}
      </Label>
    </div>
  )
}
